import React, { useEffect } from 'react';
import './App.css';

function AboutUs() {
    useEffect(() => {
        document.title = 'About Us - Convert MathML to LaTeX Online | MathConvert';
        document.querySelector('meta[name="description"]').setAttribute('content', 'Learn about MathConvert, a free online tool for converting MathML to LaTeX. Understand our mission and dedication to providing a seamless conversion experience.');
        document.querySelector('meta[name="keywords"]').setAttribute('content', 'about us, mathconvert, mathml to latex, converter, online tool, mission');
    }, []);

    return (
        <main className="main-content">
            <div className="converter-container">
                <div className="converter-section">
                    <div className="section-header">
                        <h2 className="section-title">About Us</h2>
                    </div>
                    <div>
                        <p>Welcome to MathConvert, your free online tool for converting MathML to LaTeX. We are dedicated to providing a seamless and efficient conversion experience for students, educators, and professionals alike.</p>
                        <p>Our mission is to simplify the process of working with mathematical expressions online. Whether you're writing research papers, creating educational materials, or just need to convert some equations, MathConvert is here to help.</p>
                        <p>MathConvert is built with accessibility and ease of use in mind. It is completely free to use, requires no registration, and works directly in your browser. We leverage powerful open-source libraries to ensure accurate and reliable conversions.</p>
                        <p>Thank you for using MathConvert! If you have any questions, feedback, or suggestions, please do not hesitate to contact us.</p>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default AboutUs;
